<div class="container">
  <br />
  <app-system-wide-message></app-system-wide-message>
  <app-embedded-map></app-embedded-map>
  <app-route-header></app-route-header>
  <app-route-status-button></app-route-status-button>
  <button type="button" class="btn btn-outline-secondary ml-1" routerLink="/schedules/{{route_id}}">Stops</button>
  <a href="{{pdfUrl}}" class="btn btn-outline-secondary ml-1">PDF</a>
  <br />
  <br />

  <div class="alert alert-primary" role="alert" *ngIf="selected_special_service">
    We are operating <strong>modified service</strong> on this day. Make sure to check our service alerts and advisories for other changes in service.
  </div>

  <div class="form-group" [formGroup]="formGroup">
    <label for="dateControlSelect">Date</label>
    <div class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text btn btn-outline-secondary calendar" id="inputGroup-sizing-default"
          (click)="serviceDate.toggle()"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar3" viewBox="0 0 16 16">
            <path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z"/>
            <path d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
          </svg></span>
      </div>
      <input #serviceDate="ngbDatepicker" type="text" class="form-control" aria-label="Default"
        aria-describedby="inputGroup-sizing-default" [formControlName]="'date-select'" ngbDatepicker firstDayOfWeek="7"/>
    </div>
  </div>

  <app-route-direction-selector></app-route-direction-selector>
  <br />
  <ng-container *ngIf="first_stop != ''">
    <table class="table table-responsive table-bordered" data-toggle="table">
      <thead>
        <tr>
          <th scope="col">Stops</th>
          <ng-container *ngFor="let times of timetable[first_stop]">
            <td><a routerLink="/schedule/trip/{{times[1]}}">{{times[0]}}</a></td>
          </ng-container>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let stop of stops">
          <th scope="row">{{stop}}</th>
          <ng-container *ngFor="let times of timetable[stop]">
            <td>{{times[2]}}</td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </ng-container>
</div>
<app-main-footer></app-main-footer>
